import { ComponentType } from "react";
import CustomerBillPage from "./pages/billing_managment/CustomerBillPage";
import NotePage from "./pages/billing_managment/NotePage";
import PaymentPage from "./pages/billing_managment/PaymentPage";
import ProviderBillPage from "./pages/billing_managment/ProviderBillPage";
import AccountPage from "./pages/companies/AccountPage";
import ProfilePage from "./pages/companies/ProfilePage";
import EmailTemplatePage from "./pages/configuration/EmailTemplatePage";
import InvoiceTemplatePage from "./pages/configuration/InvoiceTemplatePage";
import NotificationsPage from "./pages/configuration/NotificationsPage";
import OperatorPage from "./pages/configuration/OperatorPage";
import OperatorPrefixesPage from "./pages/configuration/OperatorPrefixesPage";
import RateTemplatePage from "./pages/configuration/RateTemplatePage";
import ImportRoutingPlanPage from "./pages/cutomer/ImportRoutingPlanPage";
import RoutingPlanDetailsPage from "./pages/cutomer/RoutingPlanDetailsPage";
import RoutingPlanPage from "./pages/cutomer/RoutingPlanPage";
import FallBackRoutingPage from "./pages/intelligent_routing/FallBackRoutingPage";
import SubRoutingPage from "./pages/intelligent_routing/SubRoutingPage";
import TPSRoutingPage from "./pages/intelligent_routing/TPSRoutingPage";
import ContentTranslationPage from "./pages/intelligent_routing/translation/ContentPage";
import SenderTranslationPage from "./pages/intelligent_routing/translation/SenderPage";
import LiveGatewayPage from "./pages/message_activity/LiveGatewayPage";
import MessageReSubmissionPage from "./pages/message_activity/MessageReSubmissionPage";
import MessageTrackerPage from "./pages/message_activity/MessageTrackerPage";
import CostPlanPage from "./pages/provider/CostPlanPage";
import ImportCostPlanPage from "./pages/provider/ImportCostPlanPage";
import TestingPage from "./pages/provider/TestingPage";
import RolePermissionPage from "./pages/user_management/RolePermissionPage";
import UsersPage from "./pages/user_management/UsersPage";
import LiveMonitorPage from "./pages/message_activity/LiveMonitorPage";
import PcapTracePage from "./pages/message_activity/PcapTracePage";
import SOAPage from "./pages/billing_managment/SOAPage";
import RepricingPage from "./pages/billing_managment/RepricingPage";
import RolePage from "./pages/user_management/RolesPage";
import WhiteListedIps from "./pages/configuration/WhiteListedIps";
import InboundEmailConfigPage from "./pages/configuration/InboundEmailConfigPage";
import ProfileCostImportConfigPage from "./pages/configuration/ProfileCostImportConfigPage";
import PendingCostImportsPage from "./pages/configuration/PendingCostImportsPage";
import VpnTunnelPage from "./pages/configuration/VpnTunnelPage";
import ServiceProviderCostPage from "./pages/provider/ServiceProviderCostPage";
import ImportServiceProviderCostPage from "./pages/provider/ImportServiceProviderCostPage";
import ServiceProviderPage from "./pages/provider/ServiceProviderPage";
import ServiceProviderBillPage from "./pages/billing_managment/ServiceProviderBillPage";
import CurrencyPage from "./pages/configuration/CurrencyPage";

export interface IRoute {
  id: string;
  label: string;
  roles?: string[];
  subpages?: IPageRoute[];
}

export interface IPageRoute extends IRoute {
  title: string;
  link: string;
  /** Matches the API "page" name from /users/permissions — used to look up allowed permissions */
  pageKey?: string;
  /** Inline permission list — used directly when no pageKey API entry exists (e.g. import pages) */
  permissions?: string[];
  component?: ComponentType;
}

export const FULL_ACCESS_ROLES = ["SUPER", "ADMIN"];


export const routes: IRoute[] = [
  {
    label: "User Management",
    id: "user-management",
    roles: ["SUPER"],
    subpages: [
      {
        id: "users",
        pageKey: "USERS",
        label: "Users",
        link: "/user_management/users",
        title: "User Management / Users",
        component: UsersPage,
      },
      {
        id: "roles",
        pageKey: "ROLES",
        label: "Roles",
        link: "/user_management/roles",
        title: "User Management / Roles",
        component: RolePage,
      },
      {
        id: "role-permissions",
        pageKey: "ROLE_PERMISSIONS",
        label: "Role Permission",
        link: "/user_management/role",
        title: "User Management / Role Permission",
        component: RolePermissionPage,
      },
    ],
  },
  {
    label: "Companies",
    id: "companies",
    roles: ["COMPANIES"],
    subpages: [
      {
        id: "profile",
        pageKey: "PROFILE",
        label: "Profile",
        link: "/companies/profiles",
        title: "Companies / Account Profile",
        component: ProfilePage,
      },
      {
        id: "account",
        pageKey: "ACCOUNTS",
        label: "Accounts",
        link: "/companies/account",
        title: "Companies / Account",
        component: AccountPage,
      },
    ],
  },
  {
    label: "Service Provider",
    id: "service_provider_group",
    roles: ["PROVIDER"],
    subpages: [
      {
        id: "service_provider",
        pageKey: "SERVICE_PROVIDER",
        label: "Service Provider",
        link: "/provider/service_provider",
        title: "Service Provider / Service Provider",
        component: ServiceProviderPage,
      },
      {
        id: "service_provider_cost",
        pageKey: "SERVICE_PROVIDER_COST",
        label: "Service Provider Cost",
        link: "/provider/service_provider_cost",
        title: "Service Provider / Service Provider Cost",
        component: ServiceProviderCostPage,
      },
      {
        id: "import_service_provider_cost",
        pageKey: "IMPORT_SERVICE_PROVIDER_COST",
        label: "Import Service Provider Cost",
        link: "/provider/import_service_provider_cost",
        title: "Service Provider / Import Service Provider Cost",
        component: ImportServiceProviderCostPage,
      },
    ],
  },
  {
    label: "Provider",
    id: "provider",
    roles: ["PROVIDER"],
    subpages: [
      {
        id: "cost_plan",
        pageKey: "COST_PLAN",
        label: "Cost Plan",
        link: "/provider/cost_plan",
        title: "Provider / Cost Plan",
        component: CostPlanPage,
      },
      {
        id: "import_cost_plan",
        pageKey: "IMPORT_COST_PLAN",
        label: "Import Cost Plan",
        link: "/provider/import_cost_plan",
        title: "Provider / Import Cost Plan",
        component: ImportCostPlanPage,
      },
      {
        id: "pending_cost_imports",
        pageKey: "PENDING_COST_IMPORTS",
        label: "Pending Cost Imports",
        link: "/configuration/pending_cost_imports",
        title: "Provider / Pending Cost Imports",
        component: PendingCostImportsPage,
      },
      {
        id: "testing",
        pageKey: "TESTING",
        label: "Manual Testing",
        link: "/provider/testing",
        title: "Provider / Manual Testing",
        component: TestingPage,
      },
    ],
  },
  {
    label: "Customer",
    id: "customer",
    roles: ["CUSTOMER"],
    subpages: [
      {
        id: "routing_plan",
        pageKey: "ROUTING_PLAN",
        label: "Routing Plan",
        link: "/customer/routing_plan",
        title: "Customer / Routing Plan",
        component: RoutingPlanPage,
      },
      {
        id: "routing_plan_details",
        pageKey: "ROUTING_PLAN_DETAILS",
        label: "Routing Plan Details",
        link: "/customer/routing_plan_details",
        title: "Customer / Routing Plan Details",
        component: RoutingPlanDetailsPage,
      },
      {
        id: "import_routing_plan",
        pageKey: "IMPORT_RATE_ROUTE",
        label: "Import Rate/Route",
        link: "/customer/import_routing_plan",
        title: "Customer / Import Routing Plan",
        component: ImportRoutingPlanPage,
      },
    ],
  },
  {
    label: "Intelligent Routing",
    id: "intelligent_routing",
    roles: ["INTELLIGENT_ROUTE"],
    subpages: [
      {
        id: "fall_back_routing",
        pageKey: "FALLBACK_ROUTING",
        label: "FallBack Routing",
        link: "/intelligent_routing/fall_back_routing",
        title: "Intelligent Routing / FallBack Routing",
        component: FallBackRoutingPage,
      },
      {
        id: "sub_routing",
        pageKey: "SUB_ROUTING",
        label: "Sub Routing",
        link: "/intelligent_routing/sub_routing",
        title: "Intelligent Routing / Sub Routing",
        component: SubRoutingPage,
      },
      {
        id: "tps_routing",
        pageKey: "TPS_ROUTING",
        label: "TPS Routing",
        link: "/intelligent_routing/tps_routing",
        title: "Intelligent Routing / TPS Routing",
        component: TPSRoutingPage,
      },
      {
        id: "sender-translation",
        pageKey: "SENDER_TRANSLATION",
        label: "Sender Translation",
        link: "/intelligent_routing/translation/sender",
        title: "Intelligent Routing / Translation / Sender",
        component: SenderTranslationPage,
      },
      {
        id: "content-translation",
        pageKey: "CONTENT_TRANSLATION",
        label: "Content Translation",
        link: "/intelligent_routing/translation/content",
        title: "Intelligent Routing / Translation / Content",
        component: ContentTranslationPage,
      },
    ],
  },
  {
    label: "Message Activity",
    id: "message_activity",
    roles: ["MESSAGE_ACTIVITY"],
    subpages: [
      {
        id: "message_tracker",
        pageKey: "MESSAGE_TRACKER",
        label: "Message Tracker",
        link: "/message_activity/message_tracker",
        title: "Message Activity / Message Tracker",
        component: MessageTrackerPage,
      },
      {
        id: "live_gateway",
        pageKey: "LIVE_GATEWAY",
        label: "Live Gateway",
        link: "/message_activity/live_gateway",
        title: "Message Activity / Live Gateway",
        component: LiveGatewayPage,
      },
      {
        id: "live_monitor",
        pageKey: "LIVE_MONITOR",
        label: "Live Monitor",
        link: "/message_activity/live_monitor",
        title: "Message Activity / Live Monitor",
        component: LiveMonitorPage,
      },
      {
        id: "message_re_submission",
        pageKey: "MESSAGE_RESUBMISSION",
        label: "Message Re-Submission",
        link: "/message_activity/message_re_submission",
        title: "Message Activity / Message Re-Submission",
        component: MessageReSubmissionPage,
      },
      {
        id: "pcap_trace",
        pageKey: "PCAP_TRACES",
        label: "PCAP Trace",
        link: "/message_activity/pcap_trace",
        title: "Message Activity / PCAP Trace",
        component: PcapTracePage,
      },
    ],
  },
  {
    label: "Billing Management",
    id: "billing_management",
    roles: ["BILLING_MANAGEMENT"],
    subpages: [
      {
        id: "customer_bill",
        pageKey: "CUSTOMER_BILL",
        label: "Customer Bill",
        link: "/billing_management/customer_bill",
        title: "Billing Management / Customer Bill",
        component: CustomerBillPage,
      },
      {
        id: "provider_bill",
        pageKey: "PROVIDER_BILL",
        label: "Provider Bill",
        link: "/billing_management/provider_bill",
        title: "Billing Management / Provider Bill",
        component: ProviderBillPage,
      },
      {
        id: "service_provider_bill",
        pageKey: "SERVICE_PROVIDER_BILL",
        label: "Service Provider Bill",
        link: "/billing_management/service_provider_bill",
        title: "Billing Management / Service Provider Bill",
        component: ServiceProviderBillPage,
      },
      {
        id: "payment",
        pageKey: "PAYMENT",
        label: "Payment",
        link: "/billing_management/payment",
        title: "Billing Management / Payment",
        component: PaymentPage,
      },
      {
        id: "note",
        pageKey: "NOTES",
        label: "Notes",
        link: "/billing_management/note",
        title: "Billing Management / Note",
        component: NotePage,
      },
      {
        id: "soa",
        pageKey: "SOA",
        label: "SOA",
        link: "/billing_management/soa",
        title: "Billing Management / SOA",
        component: SOAPage,
      },
      {
        id: "repricing",
        pageKey: "MESSAGE_REPRICING",
        label: "Message Re-Pricing",
        link: "/billing_management/repricing",
        title: "Billing Management / Message Re-Pricing",
        component: RepricingPage,
      },
      {
        id: "currency",
        pageKey: "CURRENCY",
        label: "Currency",
        link: "/configuration/currency",
        title: "Billing Management / Currency",
        component: CurrencyPage,
      },
    ],
  },
  {
    label: "Configuration",
    id: "configuration",
    roles: ["CONFIGURATION"],
    subpages: [
      {
        id: "operators",
        pageKey: "OPERATORS",
        label: "Operators",
        link: "/configuration/operators",
        title: "Configuration / Operators",
        component: OperatorPage,
      },
      {
        id: "prefixes",
        pageKey: "PREFIXES",
        label: "Prefixes",
        link: "/configuration/prefixes",
        title: "Configuration / Prefixes",
        component: OperatorPrefixesPage,
      },
      {
        id: "invoice_template",
        pageKey: "INVOICE_FILE",
        label: "Invoice File",
        link: "/configuration/invoice",
        title: "Configuration / Invoice File",
        component: InvoiceTemplatePage,
      },
      {
        id: "rate_template",
        pageKey: "RATE_FILE",
        label: "Rate File",
        link: "/configuration/rate_template",
        title: "Configuration / Rate File",
        component: RateTemplatePage,
      },
      {
        id: "email_template",
        pageKey: "EMAIL_TEMPLATE",
        label: "Email Template",
        link: "/configuration/email",
        title: "Configuration / Email Template",
        component: EmailTemplatePage,
      },
      {
        id: "whitelisted_ips",
        pageKey: "WHITELISTED_IPS",
        label: "Whitelisted IPs",
        link: "/configuration/whitelisted_ips",
        title: "Configuration / Whitelisted IPs",
        component: WhiteListedIps,
      },
      {
        id: "notifications",
        pageKey: "NOTIFICATIONS",
        label: "Notifications",
        link: "/configuration/notifications",
        title: "Configuration / Notifications",
        component: NotificationsPage,
      },
      {
        id: "inbound_email_config",
        pageKey: "INBOUND_EMAIL_CONFIG",
        label: "Inbound Email Config",
        link: "/configuration/inbound_email_config",
        title: "Configuration / Inbound Email Config",
        component: InboundEmailConfigPage,
      },
      {
        id: "profile_cost_import_config",
        pageKey: "PROFILE_COST_IMPORT_CONFIG",
        label: "Profile Cost Import Config",
        link: "/configuration/profile_cost_import_config",
        title: "Configuration / Profile Cost Import Config",
        component: ProfileCostImportConfigPage,
      },
      {
        id: "vpn_tunnels",
        pageKey: "VPN_TUNNELS",
        label: "VPN Tunnels",
        link: "/configuration/vpn_tunnels",
        title: "Configuration / VPN Tunnels",
        component: VpnTunnelPage,
      },
    ],
  },
];

export function flattenRoutes(routes: IRoute[]): IPageRoute[] {
  return routes.flatMap(flattenRoute);
}

function flattenRoute(route: IRoute): IPageRoute[] {
  const result: IPageRoute[] = [];
  if (route.subpages) {
    route.subpages.forEach((subpage) => result.push(...flattenRoute(subpage)));
  }
  if ((route as IPageRoute).link) {
    result.push(route as IPageRoute);
  }
  return result;
}
